<template>
   <div id="ContainerClinicalPatientInfo">
     <!--<Patient v-if="!this.$store.state.companies.isUAE" v-bind:editMode="this.$attrs.editMode" v-bind:HaveChanges="HaveChanges"/>
      <PatientUAE v-else v-bind:editMode="this.$attrs.editMode" v-bind:HaveChanges="HaveChanges"/>-->

      <PatientSwitcher v-bind:editMode="this.$attrs.editMode" v-bind:HaveChanges="HaveChanges" @load="Load"></PatientSwitcher>

    </div>
</template>

<script>
//import Patient from '@/components/pages/patients/Patient'
//import PatientUAE from '@/components/pages/patients/PatientUAE'
import PatientSwitcher from '@/components/pages/patients/PatientSwitcher'
import EnumService from "@/services/enum.service";
import { EventBus } from '@/event-bus.js';
import DBFunctions from '@/common/DBFunctions.js'
import Permission from '@/common/Permission'


/*

     component: async () => {
          const isUAE = await store.state.companies.isUAE;         
          return isUAE ? PatientUAE : Patient;
        },

*/

export default {
  
beforeRouteLeave(to, from, next) {
	if (this.HaveChanges) {
		this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
          title: this.$tc('Shared.Patient'),
          okTitle: this.$t('Shared.Save'),
          cancelTitle: this.$t('Shared.BtnDismiss'),
          footerClass: 'p-2',
          titleClass: 'modal-title modal-type-warning'
        })
          .then(value => {
            if(!value){             
              next();
            } else {
              EventBus.$emit('onSave', true);
              next();              
            }
          })		
	} else {
		next()
	}
    },

  name: 'ClinicalPatientInfo',
  mixins: [DBFunctions,Permission],
     components:{/*Patient,PatientUAE*/PatientSwitcher},
      data(){
    return{
        OptionsRightMenu:{
			visible:true,
			ItemsList:[],
			btnvisible:true,
			itemdisabled: false,
			PatientCode:''         
		},
		HaveChanges:false,
    }
  },

  methods:{
  Load(isload){
    this.$emit('load', isload); 
  }
  },

	created(){
        EventBus.$on("HaveChanges", function (e) {  
          this.HaveChanges = e;
     }.bind(this));
	},

    mounted() {
        this.OptionsRightMenu.visible = true;    
      this.OptionsRightMenu.btnvisible = true;
      this.OptionsRightMenu.itemdisabled = false;
      this.$emit('getVisibleMenu', this.OptionsRightMenu);
      this.$emit('getBtnRightMenu', this.OptionsRightMenu);
      this.OptionsRightMenu.ItemsList = this.$route.name.includes('appointmentDB-') ? EnumService.AppointmentItems : EnumService.ClinicalItems
      this.$emit('getVisibleMenu', this.OptionsRightMenu);		
		
	},
};
</script>


